import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Cotacao from './pages/Cotacao';
import Historico from './pages/Historico'; // 1. IMPORTE A NOVA PÁGINA
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import './App.css';

function PrivateRoute({ children }) {
  const [user, loading] = useAuthState(auth);
  if (loading) {
    return <div>Carregando...</div>;
  }
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Cotacao /></PrivateRoute>} />
        {/* 2. ADICIONE A NOVA ROTA AQUI */}
        <Route path="/historico" element={<PrivateRoute><Historico /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
